var map = {
	"./29_car.mp3": "db4e",
	"./30_doll.mp3": "5ce5",
	"./31_ball.mp3": "b293",
	"./33_one.mp3": "93b2",
	"./34_two.mp3": "7f7e",
	"./35_three.mp3": "2ea5",
	"./M_Brilliant.mp3": "3e68",
	"./M_Excellent.mp3": "6eec",
	"./M_Fantastic.mp3": "2ec5",
	"./M_Great.mp3": "5fce",
	"./M_Perfect.mp3": "1975",
	"./M_Think again.mp3": "3dff",
	"./M_Try again.mp3": "830b",
	"./M_Very good.mp3": "75ed",
	"./M_Well done.mp3": "f317",
	"./M_Work harder.mp3": "43cb",
	"./click.mp3": "4f40",
	"./false.mp3": "a3c9",
	"./true.mp3": "8b55"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "870d";